module.exports = __webpack_public_path__ + "media/images/icons/flags/MU-0025b6957f99b6899f205489b73f55f1.svg";